import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  Typography,
} from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { SavedBrandContext } from "contexts/SavedBrand";
import { UserIntegrationsContext } from "contexts/UserIntegrations";
import { useContext } from "react";

import { useCollection } from "utils/useCollection";

import { Page } from "../schema";
import LeftDrawerWrapper from "./Wrapper";
import LeftDrawerListItem from "./components/ListItem";
import styles from "./styles";

interface Props {
  open: boolean;
  handleClose: () => void;
  handleLogOut: () => void;
  openSettingsMenuOnly?: boolean;
  anchorEl?: HTMLElement | null;
}

const TopNavigationLeftDrawer = ({
  open,
  handleClose,
  handleLogOut,
  openSettingsMenuOnly,
  anchorEl,
}: Props) => {
  const { currentUser, currentOrg } = useContext(OrganizationUserContext);
  const { userIntegration } = useContext(UserIntegrationsContext);
  const { setOpenSavedBrandsOnMobile } = useContext(SavedBrandContext);

  const { getTotal } = useCollection();
  const total = getTotal();

  const openSavedBrands = () => {
    setOpenSavedBrandsOnMobile(true);
  };

  return (
    <LeftDrawerWrapper
      open={open}
      handleClose={handleClose}
      openSettingsMenuOnly={openSettingsMenuOnly}
      anchorEl={anchorEl}
    >
      <List sx={{ width: 250 }}>
        <Box sx={styles.name}>
          <strong>{currentUser?.name}</strong> ({currentUser?.email})
        </Box>

        {userIntegration?.email &&
          userIntegration?.email !== currentUser?.email && (
            <Box sx={styles.email}>
              Emails are sent from <strong>{userIntegration?.email}</strong>
            </Box>
          )}

        {openSettingsMenuOnly ? null : (
          <>
            <Divider sx={{ my: 1 }} />

            <LeftDrawerListItem page={Page.HOME} handleClose={handleClose} />
            <LeftDrawerListItem
              page={currentOrg?.showAutopilotPlan ? Page.AUTOPILOT : Page.VA}
              handleClose={handleClose}
            />

            <Box sx={{ mt: 2 }}>
              <Typography
                gutterBottom
                sx={{ pl: 2, color: "purple.main" }}
                variant="caption"
              >
                Outreach Tools
              </Typography>

              <LeftDrawerListItem
                page={Page.BRANDS}
                hasSubmenu={total > 0}
                onSubmenuClick={openSavedBrands}
                handleClose={handleClose}
                subMenuIcon="fa-thin fa-bookmark"
                subMenuText="View Saved Brands"
              />
              <LeftDrawerListItem
                page={Page.RECOMMENDATIONS}
                handleClose={handleClose}
              />
              <LeftDrawerListItem page={Page.INBOX} handleClose={handleClose} />
              <LeftDrawerListItem
                page={Page.CAMPAIGNS}
                handleClose={handleClose}
              />
              <LeftDrawerListItem page={Page.LOCAL} handleClose={handleClose} />
            </Box>
          </>
        )}

        {openSettingsMenuOnly ? (
          <Box>
            <Divider sx={{ my: 2 }} />
          </Box>
        ) : (
          <></>
        )}

        <Box sx={{ mt: 2 }}>
          <Typography
            gutterBottom
            sx={{ pl: 2, color: "purple.main" }}
            variant="caption"
            color="textSecondary"
          >
            Account & Settings
          </Typography>

          {openSettingsMenuOnly ? (
            <LeftDrawerListItem
              page={currentOrg?.showAutopilotPlan ? Page.AUTOPILOT : Page.VA}
              handleClose={handleClose}
            />
          ) : null}
          <LeftDrawerListItem page={Page.SETTINGS} handleClose={handleClose} />
          <LeftDrawerListItem page={Page.TEMPLATES} handleClose={handleClose} />
          <LeftDrawerListItem page={Page.PROFILE} handleClose={handleClose} />

          <ListItem disablePadding>
            <ListItemButton onClick={handleLogOut}>
              <Box
                component={"i"}
                className={"fa-thin fa-sign-out"}
                sx={{ mr: 1 }}
              />{" "}
              Log Out
            </ListItemButton>
          </ListItem>
        </Box>
      </List>
    </LeftDrawerWrapper>
  );
};

export default TopNavigationLeftDrawer;
